import { BrandCategory } from 'types/BrandProfile.type';

export const BRAND = 'brand';
export const MY_BRANDS = 'my_brands';
export const AGENCY_BRANDS = 'agency_brands';

export const BRAND_FILTER_QUERY_PARAM = 'filter';
export const BRAND_CATEGORIES: Array<BrandCategory> = [
  'accessories',
  'beauty',
  'footwear',
  'kids',
  'lingerie',
  'mainstream',
  'outdoor',
  'premium',
  'sports',
  'streetwear',
  'tech',
  'other'
];
